<div class="container-fluid admin-page pos-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'POS terminals' | translate }}</h1>
            <p>{{ 'Manage terminal details, receipts, service options and device pairing.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="loadTerminals()" [disabled]="isLoading" class="admin-refresh-button" type="button">
                <i [class.spinning]="isLoading"
                   class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <div class="admin-toolbar">
        <label class="admin-search-field">
            <span>{{ 'Search terminals' | translate }}</span>
            <div class="admin-search-input">
                <i class="material-icons">search</i>
                <input (ngModelChange)="onSearchTextChanged($event)" [ngModel]="searchText"
                       [placeholder]="'Search by client, terminal, address or phone' | translate" type="search">
            </div>
        </label>
        <label class="admin-page-size">
            <span>{{ 'Rows' | translate }}</span>
            <select (ngModelChange)="changePageSize()" [(ngModel)]="pageSize">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
            </select>
        </label>
    </div>

    <div *ngIf="isLoading" class="state-card admin-page-state">
        <i class="material-icons spinning">refresh</i><span>{{ 'Loading POS terminals...' | translate }}</span>
    </div>
    <div *ngIf="!isLoading && loadError !== ''" class="state-card admin-page-state error-state">
        <i class="material-icons">error_outline</i><span>{{ loadError | translate }}</span>
        <button (click)="loadTerminals()" type="button">{{ 'Try again' | translate }}</button>
    </div>

    <div *ngIf="!isLoading && loadError === '' && filteredTerminals.length > 0"
         class="pos-table-wrap admin-data-table-wrap">
        <table class="pos-table admin-data-table">
            <thead>
            <tr>
                <th [attr.aria-sort]="tableSort.getAriaSort('terminalId')">
                    <button (click)="tableSort.toggle('terminalId')" class="admin-sort-button" type="button">
                        <span>{{ 'Terminal ID' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('terminalId', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('terminalId', 'desc')" class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th [attr.aria-sort]="tableSort.getAriaSort('installationDate')">
                    <button (click)="tableSort.toggle('installationDate')" class="admin-sort-button" type="button">
                        <span>{{ 'Installation date' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('installationDate', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('installationDate', 'desc')"
                               class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th [attr.aria-sort]="tableSort.getAriaSort('client')">
                    <button (click)="tableSort.toggle('client')" class="admin-sort-button" type="button">
                        <span>{{ 'Client' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('client', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('client', 'desc')" class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th [attr.aria-sort]="tableSort.getAriaSort('address')">
                    <button (click)="tableSort.toggle('address')" class="admin-sort-button" type="button">
                        <span>{{ 'Address' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('address', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('address', 'desc')" class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th [attr.aria-sort]="tableSort.getAriaSort('lastOrder')">
                    <button (click)="tableSort.toggle('lastOrder')" class="admin-sort-button" type="button">
                        <span>{{ 'Last order' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('lastOrder', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('lastOrder', 'desc')" class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th [attr.aria-sort]="tableSort.getAriaSort('totalOrders')">
                    <button (click)="tableSort.toggle('totalOrders')" class="admin-sort-button" type="button">
                        <span>{{ 'Total orders' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('totalOrders', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('totalOrders', 'desc')" class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th [attr.aria-sort]="tableSort.getAriaSort('pairingCode')">
                    <button (click)="tableSort.toggle('pairingCode')" class="admin-sort-button" type="button">
                        <span>{{ 'Pairing code' | translate }}</span>
                        <span class="admin-sort-indicator">
                            <i [class.active]="tableSort.isDirection('pairingCode', 'asc')" class="material-icons">arrow_drop_up</i>
                            <i [class.active]="tableSort.isDirection('pairingCode', 'desc')" class="material-icons">arrow_drop_down</i>
                        </span>
                    </button>
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr (click)="openModal(terminal)" (keydown.enter)="openModal(terminal)"
                *ngFor="let terminal of getPagedTerminals()" tabindex="0">
                <td [attr.data-label]="'Terminal ID' | translate">{{ terminal.IdTerminal || '-' }}</td>
                <td [attr.data-label]="'Installation date' | translate">{{ terminal.EntryDate | date:'dd.MM.yyyy HH:mm' }}</td>
                <td [attr.data-label]="'Client' | translate"><strong>{{ terminal.ClientName || '-' }}</strong></td>
                <td [attr.data-label]="'Address' | translate" class="address-cell">{{ terminal.Address || '-' }}</td>
                <td [attr.data-label]="'Last order' | translate">
                    {{ terminal.LastOrderDate ? (terminal.LastOrderDate | date:'dd.MM.yyyy HH:mm') : '-' }}
                </td>
                <td [attr.data-label]="'Total orders' | translate"><strong>{{ terminal.TotalOrders || 0 }}</strong></td>
                <td [attr.data-label]="'Pairing code' | translate">
                    <strong [class.paired-label]="isPaired(terminal)" class="table-pairing-code">
                        {{ (isPaired(terminal) ? 'Paired' : getPairingCode(terminal)) | translate }}
                    </strong>
                </td>
                <td class="details-cell">
                    <button (click)="openModal(terminal); $event.stopPropagation()"
                            [attr.aria-label]="'Edit POS' | translate"
                            class="details-button" type="button"><i class="material-icons">edit</i></button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="!isLoading && loadError === '' && filteredTerminals.length === 0"
         class="state-card admin-page-state">
        <i class="material-icons">point_of_sale</i>
        <span>{{ (searchText === '' ? 'No POS terminals were found.' : 'No POS terminals match this search.') | translate }}</span>
    </div>

    <footer *ngIf="!isLoading && loadError === '' && filteredTerminals.length > 0" class="admin-pagination">
        <span class="admin-pagination-summary">
            {{ 'Showing' | translate }} {{ getFirstItemNumber() }}-{{ getLastItemNumber() }}
            {{ 'of' | translate }} {{ filteredTerminals.length }} {{ 'terminals' | translate }}
        </span>
        <div class="admin-pagination-buttons">
            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
                    [attr.aria-label]="'Previous page' | translate" type="button">
                <i class="material-icons">chevron_left</i>
            </button>
            <button (click)="goToPage(page)" *ngFor="let page of getVisiblePages()"
                    [attr.aria-current]="page === currentPage ? 'page' : null"
                    [class.active]="page === currentPage" type="button">{{ page }}
            </button>
            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === getTotalPages()"
                    [attr.aria-label]="'Next page' | translate" type="button">
                <i class="material-icons">chevron_right</i>
            </button>
        </div>
    </footer>
</div>

<div (click)="closeModal()" *ngIf="selectedPos" class="pos-modal-backdrop">
    <article (click)="$event.stopPropagation()" aria-modal="true" class="pos-modal" role="dialog">
        <header class="pos-modal-header">
            <div>
                <span>{{ 'POS terminal' | translate }}</span>
                <strong>{{ (selectedPos.ClientName || selectedPos.IdTerminal || 'POS settings') | translate }}</strong>
            </div>
            <button (click)="closeModal()"
                    [disabled]="isSaving || isResettingPairingCode || isSavingPosAppVersion"
                    [attr.aria-label]="'Close POS settings' | translate" class="modal-close" type="button">
                <i class="material-icons">close</i>
            </button>
        </header>

        <div class="pos-modal-body">
            <section class="pairing-panel">
                <div>
                    <span>{{ 'Device pairing' | translate }}</span>
                    <strong>{{ (isPaired(selectedPos) ? 'Paired' : 'Waiting for device') | translate }}</strong>
                </div>
                <button (click)="resetPairingCode()" *ngIf="isPaired(selectedPos)"
                        [disabled]="isResettingPairingCode || isSaving || isSavingPosAppVersion"
                        class="reset-pairing-button" type="button">
                    <i class="material-icons">sync_lock</i>
                    <span>{{ (isResettingPairingCode ? 'Generating...' : 'Reset pairing code') | translate }}</span>
                </button>
                <div *ngIf="!isPaired(selectedPos)" class="pairing-code">
                    <span>{{ 'Pairing code' | translate }}</span><strong>{{ getPairingCode(selectedPos) }}</strong>
                </div>
            </section>

            <section class="pos-version-panel">
                <div class="pos-version-heading">
                    <div>
                        <span>{{ 'POS application' | translate }}</span>
                        <strong>{{ 'Device-specific version' | translate }}</strong>
                    </div>
                    <i class="material-icons">system_update</i>
                </div>

                <div *ngIf="isLoadingPosAppVersion" class="pos-version-state">
                    <i class="material-icons spinning">refresh</i>
                    <span>{{ 'Loading POS version...' | translate }}</span>
                </div>

                <div *ngIf="!isLoadingPosAppVersion && posAppVersionError !== ''"
                     class="pos-version-state error">
                    <i class="material-icons">error_outline</i>
                    <span>{{ posAppVersionError | translate }}</span>
                    <button (click)="loadPosAppVersion(originalIdTerminal)"
                            type="button">{{ 'Try again' | translate }}
                    </button>
                </div>

                <div *ngIf="posAppVersionLoaded && !isLoadingPosAppVersion" class="pos-version-editor">
                    <label>
                        <span>{{ 'POS version' | translate }}</span>
                        <input (ngModelChange)="onPosAppVersionChanged($event)"
                               [disabled]="isSavingPosAppVersion"
                               [ngModel]="posAppVersion"
                               [readonly]="!posAppVersionExists"
                               autocomplete="off"
                               spellcheck="false">
                        <small *ngIf="!posAppVersionExists">
                            {{ 'No device-specific version exists. Version' | translate }} {{ posAppVersion }}
                            {{ 'will be added.' | translate }}
                        </small>
                    </label>
                    <button (click)="savePosAppVersion()" [disabled]="!canSavePosAppVersion()"
                            class="save-pos-version-button" type="button">
                        <i class="material-icons">save</i>
                        <span>{{ getPosAppVersionButtonLabel() | translate }}</span>
                    </button>
                </div>
            </section>

            <form (ngSubmit)="saveTerminal()" class="pos-form">
                <div class="pos-editor-layout">
                    <div class="pos-form-column">
                        <section class="form-panel">
                            <h2>{{ 'Terminal details' | translate }}</h2>
                            <div class="form-grid">
                                <label><span>{{ 'Terminal ID' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.IdTerminal" name="idTerminal" required>
                                </label>
                                <label><span>{{ 'Client name' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.ClientName" name="clientName">
                                </label>
                                <label class="wide"><span>{{ 'Address' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.Address" name="address">
                                </label>
                                <label class="wide"><span>{{ 'Comments' | translate }}</span>
                                    <textarea [(ngModel)]="selectedPos.Comments" name="comments" rows="3"></textarea>
                                </label>
                                <label><span>{{ 'Email' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.Email" name="email" type="email">
                                </label>
                                <label><span>{{ 'Phone' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.Phone" inputmode="tel" name="phone">
                                </label>
                                <label><span>{{ 'Latitude' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.Latitude" name="latitude" readonly step="any"
                                           type="number">
                                </label>
                                <label><span>{{ 'Longitude' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.Longitude" name="longitude" readonly step="any"
                                           type="number">
                                </label>
                            </div>
                        </section>

                        <section class="form-panel">
                            <h2>{{ 'Receipt' | translate }}</h2>
                            <div class="form-grid">
                                <label class="wide"><span>{{ 'Receipt header' | translate }}</span>
                                    <textarea [(ngModel)]="selectedPos.ReceiptHeader" name="receiptHeader"
                                              rows="4"></textarea>
                                </label>
                                <label class="wide"><span>{{ 'Receipt footer' | translate }}</span>
                                    <textarea [(ngModel)]="selectedPos.ReceiptFooter" name="receiptFooter"
                                              rows="4"></textarea>
                                </label>
                            </div>
                        </section>

                        <section class="form-panel">
                            <h2>{{ 'Service settings' | translate }}</h2>
                            <div class="form-grid settings-grid">
                                <label><span>{{ 'Language' | translate }}</span>
                                    <select [(ngModel)]="selectedPos.Language" name="language">
                                        <option value="RO">RO</option>
                                        <option value="EN">EN</option>
                                    </select>
                                </label>
                                <label><span>{{ 'Maximum cars' | translate }}</span>
                                    <input [(ngModel)]="selectedPos.MaxCarsCount" min="0" name="maxCarsCount" step="1"
                                           type="number">
                                </label>
                                <label class="toggle-row">
                                    <input [(ngModel)]="selectedPos.IsInProduction" name="isInProduction"
                                           type="checkbox">
                                    <span>{{ 'Production environment' | translate }}</span>
                                </label>
                                <label class="toggle-row">
                                    <input [(ngModel)]="selectedPos.AllowCarSelection" name="allowCarSelection"
                                           type="checkbox">
                                    <span>{{ 'Allow car selection' | translate }}</span>
                                </label>
                                <label class="toggle-row">
                                    <input [(ngModel)]="selectedPos.AllowStreetService" name="allowStreetService"
                                           type="checkbox">
                                    <span>{{ 'Allow street service' | translate }}</span>
                                </label>
                            </div>
                        </section>
                    </div>

                    <section class="form-panel pos-map-panel">
                        <div class="pos-map-heading">
                            <div>
                                <h2>{{ 'Terminal location' | translate }}</h2>
                                <p>{{ 'Drag the marker to update the coordinates.' | translate }}</p>
                            </div>
                            <i class="material-icons">location_on</i>
                        </div>
                        <google-map [center]="posMapCenter" [options]="posMapOptions" [zoom]="posMapZoom"
                                    height="100%" width="100%">
                            <map-marker (mapDragend)="onPosMarkerDragEnd($event)"
                                        [options]="posMarkerOptions" [position]="posMapCenter">
                            </map-marker>
                        </google-map>
                    </section>
                </div>

                <div *ngIf="modalMessage !== ''" [class.error]="isModalMessageError()" class="modal-message">
                    <i class="material-icons">{{ isModalMessageError() ? 'error_outline' : 'check_circle' }}</i>
                    <span>{{ modalMessage | translate }}</span>
                </div>

                <footer class="modal-actions">
                    <button (click)="closeModal()"
                            [disabled]="isSaving || isResettingPairingCode || isSavingPosAppVersion"
                            class="cancel-button" type="button">{{ 'Cancel' | translate }}
                    </button>
                    <button [disabled]="isSaving || isResettingPairingCode || isLoadingPosAppVersion
                                || isSavingPosAppVersion"
                            class="save-button" type="submit">
                        <i class="material-icons">save</i><span>{{ (isSaving ? 'Saving...' : 'Save changes') | translate }}</span>
                    </button>
                </footer>
            </form>
        </div>
    </article>
</div>
